export const OFF = 'OFF';
export const CCW = 'CCW';
export const CW = 'CW';
